import { Component, OnInit,Input } from '@angular/core';
import * as Chart from 'chart.js'

@Component({
  selector: 'app-items-sold',
  templateUrl: './items-sold.component.html',
  styleUrls: ['./items-sold.component.css']
})
export class ItemsSoldComponent implements OnInit {

  constructor() { }

  @Input() graphData;

  ngOnInit(){
  }

  title = 'angular8chartjs';
  canvas: any;
  ctx: any;

  ngAfterViewInit() {
    this.canvas = document.getElementById("items-sold-chart");
    this.ctx = this.canvas.getContext("2d");
    var myLineChart = new Chart(this.ctx, {
      type: 'line',
      data: {
				labels: this.graphData.labels,
				datasets: this.graphData.sold_graph
      },
      options: {
        xAxes: [{
          type: 'time',
          time: {
            unit: 'day'
          }
        }],
        responsive: false,
        display : true,
        maintainAspectRatio: true,
        legend: {
          display: false
        },
        layout: {
          padding: {
             bottom: 0
          }
        },
        tooltips: {
          enabled: true,
          callbacks: {
              label: function (tooltipItem, data) {
                  const tooltip = data.datasets[tooltipItem.datasetIndex];
                  const value = tooltip.data[tooltipItem.index];
                  return value.y === 0 ? null : tooltip.label + ': ' + value.y;
              },

              title: function (tooltipItem, data) {
                const value = tooltipItem[0].value;
                return value === "0" ? null : tooltipItem[0].label;
            }
          }
        }
      },

  });
  }

}
